import { ROUTES } from '@/shared/constants/routes';
import {
  DropdownMenuItem,
  SideMenuItemType,
  MobileMenuItem,
  TabItemType,
} from '@/shared/types/navigation';
import { handleUrlOpen } from '@/shared/utils';
import { Href, router } from 'expo-router';

export const FROM_SIDE_NAV = 'sideNav';

export const DROPDOWN_MENU_ITEMS: DropdownMenuItem[] = [
  {
    label: 'Payment Portal',
    route: {
      action: () => {
        window.open('https://stripe.com', '_blank');
      },
    },
    leadingIcon: {
      source: require('@/assets/images/PaymentIcon.png'),
      width: 16,
      height: 16,
    },
    trailingIcon: {
      source: require('@/assets/images/LinkoutIcon.png'),
      width: 12,
      height: 12,
    },
  },
  {
    label: ROUTES.SETTINGS.label,
    route: ROUTES.SETTINGS,
    leadingIcon: {
      source: require('@/assets/images/SettingsIcon.png'),
      width: 16,
      height: 16,
    },
  },
  {
    label: ROUTES.HELP.label,
    route: ROUTES.HELP,
    leadingIcon: {
      source: require('@/assets/images/HelpIcon.png'),
      width: 16,
      height: 16,
    },
  },
  {
    label: 'Privacy Policy',
    route: {
      action: () => {
        router.navigate({
          pathname: ROUTES.PRIVACY.path,
          params: { from: FROM_SIDE_NAV },
        } as Href);
      },
    },
    leadingIcon: {
      source: require('@/assets/images/PrivacyIcon.png'),
      width: 16,
      height: 16,
    },
  },
  {
    label: 'Terms & Conditions',
    route: {
      action: () => {
        router.navigate({
          pathname: ROUTES.TERMS.path,
          params: { from: FROM_SIDE_NAV },
        } as Href);
      },
    },
    leadingIcon: {
      source: require('@/assets/images/TermsIcon.png'),
      width: 16,
      height: 16,
    },
  },
  {
    label: 'Log Out',
    route: 'logout',
    leadingIcon: {
      source: require('@/assets/images/LogoutIcon.png'),
      width: 16,
      height: 16,
    },
  },
] as const;

export const SIDE_MENU_ITEMS: SideMenuItemType[] = [
  {
    route: ROUTES.SESSIONS,
    default: require('@/assets/images/HomeSmIcon.png'),
    selected: require('@/assets/images/HomeSelectedSmIcon.png'),
  },
  {
    route: ROUTES.INSTANT_STYLING,
    default: require('@/assets/images/InstantSmIcon.png'),
    selected: require('@/assets/images/InstantSelectedSmIcon.png'),
  },
  {
    route: ROUTES.AVAILABILITY,
    default: require('@/assets/images/AvailabilitySmIcon.png'),
    selected: require('@/assets/images/AvailabilitySelectedSmIcon.png'),
  },
  {
    route: ROUTES.PREVIEW,
    default: require('@/assets/images/ProfileIcon.png'),
    selected: require('@/assets/images/ProfileSelectedIcon.png'),
  },
  {
    route: ROUTES.ADMIN,
    default: require('@/assets/images/DashboardSmIcon.png'),
    selected: require('@/assets/images/DashboardSelectedSmIcon.png'),
    requiresAdmin: true,
  },
] as const;

export const MOBILE_MENU_ITEMS: MobileMenuItem[] = [
  {
    label: 'Your Profile',
    route: ROUTES.PREVIEW,
    leadingIcon: {
      size: 18,
      source: require('@/assets/images/ProfileIcon.png'),
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Payment Portal',
    route: {
      action: () => handleUrlOpen('https://stripe.com'),
    },
    leadingIcon: {
      source: require('@/assets/images/PaymentIcon.png'),
      size: 23,
    },
    trailingIcon: {
      source: require('@/assets/images/LinkoutIcon.png'),
      size: 20,
    },
  },
  {
    label: ROUTES.SETTINGS.label,
    route: ROUTES.SETTINGS,
    leadingIcon: {
      source: require('@/assets/images/SettingsIcon.png'),
      size: 20,
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: ROUTES.HELP.label,
    route: ROUTES.HELP,
    leadingIcon: {
      source: require('@/assets/images/HelpIcon.png'),
      size: 20,
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Privacy Policy',
    route: {
      action: () =>
        router.navigate({
          pathname: ROUTES.PRIVACY.path,
          params: { from: FROM_SIDE_NAV },
        } as Href),
    },
    leadingIcon: {
      source: require('@/assets/images/PrivacyIcon.png'),
      size: 18.5,
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Terms & Conditions',
    route: {
      action: () =>
        router.navigate({
          pathname: ROUTES.TERMS.path,
          params: { from: FROM_SIDE_NAV },
        } as Href),
    },
    leadingIcon: {
      source: require('@/assets/images/TermsIcon.png'),
      size: 18.5,
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Log Out',
    route: 'logout',
    leadingIcon: {
      source: require('@/assets/images/LogoutIcon.png'),
      size: 24,
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
];

export const MOBILE_WEB_MENU_ITEMS: MobileMenuItem[] = [
  {
    label: 'Manage Sessions',
    route: ROUTES.SESSIONS,
    leadingIcon: {
      size: 18,
      source: require('@/assets/images/HomeSmIcon.png'),
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Instant Styling',
    route: ROUTES.INSTANT_STYLING,
    leadingIcon: {
      size: 24,
      source: require('@/assets/images/InstantFilledIcon.png'),
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Availability',
    route: ROUTES.AVAILABILITY,
    leadingIcon: {
      size: 20,
      source: require('@/assets/images/AvailabilitySmIcon.png'),
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
  },
  {
    label: 'Dashboard',
    route: ROUTES.ADMIN,
    leadingIcon: {
      size: 20,
      source: require('@/assets/images/DashboardSmIcon.png'),
    },
    trailingIcon: {
      source: require('@/assets/images/Continue.png'),
      size: 34.5,
    },
    requiresAdmin: true,
  },
  ...MOBILE_MENU_ITEMS,
];

export const STYLIST_TAB_ITEMS: TabItemType[] = [
  {
    route: ROUTES.SESSIONS,
    icon: {
      size: 26,
      source: require('@/assets/images/HomeSmIcon.png'),
    },
  },
  {
    route: ROUTES.INSTANT_STYLING,
    icon: {
      size: 30,
      source: require('@/assets/images/InstantFilledIcon.png'),
    },
  },
  {
    route: ROUTES.AVAILABILITY,
    icon: {
      size: 26,
      source: require('@/assets/images/AvailabilitySmIcon.png'),
    },
  },
];

export const CLIENT_TAB_ITEMS: TabItemType[] = [
  {
    route: ROUTES.EXPLORE,
    icon: {
      size: 26,
      source: require('@/assets/images/HomeSmIcon.png'),
    },
  },
  {
    route: ROUTES.INSTANT_STYLING,
    icon: {
      size: 30,
      source: require('@/assets/images/InstantFilledIcon.png'),
    },
  },
  {
    route: ROUTES.SESSIONS,
    icon: {
      size: 26,
      source: require('@/assets/images/AvailabilitySmIcon.png'),
    },
  },
];
